import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { components } from 'react-select'

import SelectAsyncPaginate from '../SelectAsyncPaginate'

import { loadSPTemplates } from '../../../redux/actions/ruleManager'

const Option = (props) => {
  const { innerRef, innerProps, getStyles, data } = props
  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={getStyles('option', props)}
      className="template-option"
    >
      <div className="product-info">
        <span className="product-name" title={data.name}>{data.name}</span>
      </div>
    </div>
  )
}

// https://github.com/JedWatson/react-select/issues/4170#issuecomment-682465724
const ValueContainer = (props) => {
  const { options, children, getValue } = props
  const selectCount = getValue().length
  let contents = children
  if (selectCount > 0) {
    if (selectCount === options.length) {
      contents = (
        <>
          All SP Templates selected
          { children[1] }
        </>
      )
    } else if (selectCount >= 10) {
      contents = (
        <>
          { selectCount } SP Templates selected
          { children[1] }
        </>
      )
    }
  }
  return (
    <components.ValueContainer {...props}>
      { contents }
    </components.ValueContainer>
  )
}

const MultiValueLabel = (props) => {
  const { data } = props
  return (
    <components.MultiValueLabel {...props}>
      <span className="placeholder-image" title={data.name}>
            {data.name}
      </span>

    </components.MultiValueLabel>
  )
}

const SmartpilotTemplateSelector = ({ selectedTemplates, disabled = false, showAllButton = true, onChange }) => {
  const dispatch = useDispatch()

  const [loadedSpTemplates, setLoadedSpTemplates] = useState([])

  const loadData = (accessToken, page, search) => {
    return dispatch(loadSPTemplates(accessToken, {
      page,
      search,
      countPerPage: 10,
    }))
  }

  const handleLoad = (skus) => {
    setLoadedSpTemplates(prev => ([...prev, ...skus]))
  }

  const handleSelectAll = () => {
    if (selectedTemplates === 'all' || selectedTemplates.length === loadedSpTemplates.length) {
      // If all is selected, un-select all.
      onChange([])
    } else {
      // Select all.
      onChange('all')
    }
  }

  return (
    <div className="smart-select-wrapper">
      <SelectAsyncPaginate
        keyValue="id"
        classNamePrefix="sp-template-selector"
        components={{ Option, ValueContainer, MultiValueLabel }}
        loadData={loadData}
        selection={selectedTemplates !== 'all' ? selectedTemplates : []}
        isDisabled={disabled}
        placeholder="Select SP Templates..."
        field="id"
        onChange={onChange}
        onLoad={handleLoad}
      />
      { showAllButton && (
        <button
          type="button"
          className="btn btn-white"
          disabled={disabled}
          onClick={handleSelectAll}
        >
          {
            (selectedTemplates !== 'all' && (selectedTemplates.length === 0 || selectedTemplates.length !== loadedSpTemplates.length))
              ? 'Select All'
              : 'Unselect All'
          }
        </button>
      )}
    </div>
  )
}

export default SmartpilotTemplateSelector
